export const ACCOUNT_ID_OR_ALIAS_REGEX = /^((.+)\.)sitooapps?.+\.com/

export const ACCOUNT_ID_COOKIE = 'accountId'

export const AUTH_REDIRECT_TOKEN_COOKIE = 'authRedirectToken'

export const LAST_USED_ACCOUNT_COOKIE = 'lastUsedAccount'

/**
 * Remove accountId or alias from hostname
 * Example: 2001.sitooapps-test.com => sitooapps-test.com
 */
export const getBaseHostname = (): string => {
  return location.hostname.replace(
    ACCOUNT_ID_OR_ALIAS_REGEX,
    (match, group) => {
      return match.replace(group, '')
    },
  )
}

/**
 * Remove accountId or alias from host
 * Example: 2001.sitooapps-test.com:8080 => sitooapps-test.com:8080
 */
export const getBaseHost = (): string => {
  return location.host.replace(ACCOUNT_ID_OR_ALIAS_REGEX, (match, group) => {
    return match.replace(group, '')
  })
}

export const getAccountFromHost = (): {
  accountId?: number
  accountAlias?: string
} => {
  const accountIdOrAlias = location.host.match(ACCOUNT_ID_OR_ALIAS_REGEX)?.[2]
  const isNumeric = /^\d+$/.test(accountIdOrAlias ?? '')
  const maybeAccountId = isNumeric ? Number(accountIdOrAlias) : undefined
  const maybeAccountAlias = isNumeric ? undefined : accountIdOrAlias

  return {
    accountId: maybeAccountId,
    accountAlias: maybeAccountAlias,
  }
}

export const hasAccountIdOrAliasInHost = () => {
  return ACCOUNT_ID_OR_ALIAS_REGEX.test(location.host)
}
